import { render, staticRenderFns } from "./archivioNode.vue?vue&type=template&id=a5c1e52c&scoped=true&"
import script from "./archivioNode.vue?vue&type=script&lang=ts&"
export * from "./archivioNode.vue?vue&type=script&lang=ts&"
import style0 from "./archivioNode.vue?vue&type=style&index=0&id=a5c1e52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c1e52c",
  null
  
)

export default component.exports